<template>
  <div>
    <v-img
      :src="urlImagem ? urlImagem : `profile.png`"
      :lazy-src="`profile.png`"
      height="360px"
      width="270px"
      dark
      class="mx-auto"
    >
    </v-img>

    <v-skeleton-loader
      :loading="loading"
      transition="scale-transition"
      :types="{ skeleton: 'list-item' }"
      type="skeleton"
    >
      <v-card-title
        primary-title
        class="justify-center"
        style="word-break:break-word;"
      >
        {{ nome }}
      </v-card-title>
    </v-skeleton-loader>
  </div>
</template>

<script>
import Service from "@/components/api/Service";

export default {
  data() {
    return {
      // Functions
      service: new Service(),
      urlImagem: ""
    };
  },
  created() {
    try {
      this.urlImagem = this.service.buscaImagemPerfil();
    } catch (error) {
      console.log("Erro ao buscar imagem de perfil");
    }
  },
  inheritAttrs: false,
  props: {
    nome: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
